module.exports = __webpack_public_path__ + "assets/circle-info-02e0b0.svg";